import React from 'react';
import { useGamingStore } from '../../store/gamingStore';
import GamingHubHome from './GamingHubHome';
import MinecraftUniverse from './MinecraftUniverse';
import GameDetail from './GameDetail';
import GameStore from './GameStore';
import GameLibrary from './GameLibrary';
import ReviewLibrary from './ReviewLibrary';
import HostingDashboard from '../hosting/HostingDashboard';

const GamingHub: React.FC = () => {
  const { gamingView } = useGamingStore();

  switch (gamingView) {
    case 'minecraft':
      return <MinecraftUniverse />;
    case 'hosting':
      return <HostingDashboard />;
    case 'game-detail':
      return <GameDetail />;
    case 'store':
      return <GameStore />;
    case 'library':
      return <GameLibrary />;
    case 'review-library':
      return <ReviewLibrary />;
    case 'hub':
    default:
      return <GamingHubHome />;
  }
};

export default GamingHub;
